/* eslint-disable semi */
import React from 'react';
import { Chart as ChartJs, registerables } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { isEqual } from 'lodash';
ChartJs.defaults.font.family = "'FWDCircular', 'Noto'";

export class Chart extends React.Component {
  constructor(props) {
    super(props);

    this.chartRef = React.createRef();
    this.chartInstance = null;
  }

  componentDidMount() {
    const { chartConfig } = this.props;
    this._generateChart(chartConfig);
  }

  shouldComponentUpdate(nextProps) {
    const { chartConfig } = this.props;
    if (
      !isEqual(
        JSON.stringify(this._filterPlotData(nextProps.chartConfig.data.datasets)),
        JSON.stringify(this._filterPlotData(chartConfig.data.datasets)),
      )
    ) {
      this._destroyChart();
      this._generateChart(nextProps.chartConfig);
    }

    return true;
  }

  componentWillUnmount() {
    this._destroyChart();
  }

  _filterPlotData(datasets) {
    return datasets.map((dataSet) => {
      return { data: dataSet.data, dataLabels: dataSet.datalabels };
    });
  }

  _destroyChart() {
    if (this.chartInstance !== null) {
      this.chartInstance.destroy();
    }
  }

  _generateChart(chartConfig) {
    ChartJs.register(...registerables, annotationPlugin, ChartDataLabels);
    this.chartInstance = new ChartJs(this.chartRef.current, chartConfig);
  }

  render() {
    return <canvas ref={this.chartRef} width={this.props.width} height={this.props.height} />;
  }
}
